export const BUILD_VERSION = '1781105147';
